import { useEffect } from 'react';
import { setGaUserProperties } from '~/services/analytics/gaUserProperties';
import { resolveUserGroup } from '~/services/analytics/userGroup';
import { useUser } from '~/shared/hooks/useUser';

export function useGoogleAnalyticsUserProperties({
  enabled,
}: {
  enabled?: boolean;
}) {
  const user = useUser();

  useEffect(() => {
    if (!enabled || !user?.email) {
      return;
    }

    setGaUserProperties(resolveUserGroup(user.email));
  }, [enabled, user?.email]);
}
